import { render, staticRenderFns } from "./Checkboxes.vue?vue&type=template&id=885550ca&"
import script from "./Checkboxes.vue?vue&type=script&lang=js&"
export * from "./Checkboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports